import { computed } from 'vue';

export function usePagination(props, emit) {
  // Calculate pagination items
  const paginationItems = computed(() => {
    if (props.lastPage <= 1) return [];

    const onEachSide = props.onEachSide;
    const currentPage = props.currentPage;
    const lastPage = props.lastPage;

    let items = [];

    // Always show the first page
    items.push({ type: 'page', page: 1 });

    // Calculate window start
    let windowStart = Math.max(2, currentPage - onEachSide);

    // If window start is just after page 1, don't show dots
    if (windowStart > 2) {
      items.push({ type: 'dots' });
    }

    // Add pages in the middle window
    for (let i = windowStart; i <= Math.min(lastPage - 1, currentPage + onEachSide); i++) {
      items.push({ type: 'page', page: i });
    }

    // If window end is not close to the last two pages, show dots
    if (currentPage + onEachSide < lastPage - 2) {
      items.push({ type: 'dots' });
    }

    // Always show the penultimate and last page if they exist
    if (lastPage > 2 && currentPage + onEachSide < lastPage - 1) {
      items.push({ type: 'page', page: lastPage - 1 });
    }
    if (lastPage > 1) {
      items.push({ type: 'page', page: lastPage });
    }

    return items;
  });

  return {
    paginationItems
  };
}
